import { render, staticRenderFns } from "./FeatureToggle.vue?vue&type=template&id=bd117d56"
import script from "./FeatureToggle.vue?vue&type=script&lang=js"
export * from "./FeatureToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports